import axios from 'axios'

export default {
  getCloudcasts: () => {
    return new Promise((resolve, reject) => {
      axios.get('https://api.mixcloud.com/iferadio/cloudcasts/')
      .then(res => resolve(res.data))
      .catch(err => reject(err))
    })
  },

  getCastIframe: key => {
    return new Promise((resolve, reject) => {
      axios.get(`https://api.mixcloud.com/${key}embed-json/?color=000000`)
      .then(res => resolve(res.data))
      .catch(err => reject(err))
    })
  },

  getLiveStream: () => {
    return new Promise((resolve, reject) => {
      axios.get(`https://api.mixlr.com/users/8931262/broadcast?source=embed`)
      .then(res => resolve(res.data))
      .catch(err => reject(err))
    })
  }
}